const contentLoadingAnimation = () => {
  const animatedItems = document.querySelectorAll('.animated');

  if (animatedItems.length === 0) {
    return;
  }

  const getOffset = (element) => {
    const rect = element.getBoundingClientRect(),
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
      top: rect.top + scrollTop
    };
  };

  const animateOnScroll = (activeClass, invertClass) => {
    animatedItems.forEach((animatedItem) => {
      const animatedItemHeight = animatedItem.offsetHeight;
      const animatedItemOffset = getOffset(animatedItem).top;
      const animatedItemStart = 4;

      let animatedItemPoint = window.innerHeight - animatedItemHeight / animatedItemStart;

      if (animatedItemHeight > window.innerHeight) {
        animatedItemPoint = window.innerHeight - window.innerHeight / animatedItemStart;
      }

      animatedItem.classList.add(activeClass);
      animatedItem.classList.remove(invertClass);
      if ((pageYOffset > animatedItemOffset - animatedItemPoint / 2) && pageYOffset < (animatedItemOffset + animatedItemHeight)) {
        animatedItem.classList.add(activeClass);
        animatedItem.classList.remove(invertClass);
      } else {
        animatedItem.classList.remove(activeClass);
        animatedItem.classList.remove(invertClass);
      }
    });
  };

  window.addEventListener('scroll', animateOnScroll('active'));

  setTimeout(() => {
    animateOnScroll('active');
  }, 100);

function addHandler(object, event, handler, useCapture) {
  if (object.addEventListener) {
  object.addEventListener(event, handler, useCapture ? useCapture : false);
  } else if (object.attachEvent) {
  object.attachEvent('on' + event, handler);
  }
};

 addHandler(window, 'DOMMouseScroll', wheel);

 addHandler(window, 'mousewheel', wheel);

 function wheel(event) {
  var delta;
  event = event || window.event;
  if (event.wheelDelta) {
  delta = event.wheelDelta / 120;
  if (window.opera) delta = -delta;
  } else if (event.detail) {
  delta = -event.detail / 3;
  }
  if (delta === 1) {
    animateOnScroll('active', 'invert');
  } else if (delta === -1) {
    animateOnScroll('invert', 'active');
  }
 };

};

export {contentLoadingAnimation};
